import styled from '@emotion/styled';
import emotionFirstChildSelector, {
  suppressEmotionFirstChildSelectorWarning,
} from '@/lib/styling/emotionFirstChildSelector';
import mediaQuery from '@/lib/styling/mediaQuery';

export const childCoachCommentButtonVisibilityStyling = {
  [`&:not(:hover):not(:focus-within) > .coach-comment-list.has-no-comments:not(.add-form-open),
    > .coach-comment-list.has-no-comments:not(.has-controls):not(.add-form-open)`]:
    {
      marginTop: 0,
      height: 0,
    },
  '&:not(:hover):not(:focus-within) > .coach-comment-list.has-controls:not(.has-no-comments):not(.add-form-open)':
    {
      marginBottom: -24,
    },
  '> .coach-comment-list > .add-coach-comment-button': {
    marginTop: 0,
    opacity: 0,
    height: 0,
  },
  [`:hover > .coach-comment-list > .add-coach-comment-button,
    :focus-within > .coach-comment-list > .add-coach-comment-button,
    > .coach-comment-list > .add-coach-comment-button:focus`]: {
    opacity: 1,
    height: 36.5,
    [`:not(:first-child) ${suppressEmotionFirstChildSelectorWarning}`]: {
      marginTop: 12,
    },
  },
};

const StyledFieldWrapper = styled('div')({
  position: 'relative',
  marginBottom: 22,
  display: 'flex',
  flexDirection: 'column',
  ':last-child': {
    marginBottom: 0,
  },
  [`& > ${emotionFirstChildSelector}`]: {
    flex: 1,
  },
  ...childCoachCommentButtonVisibilityStyling,
  ':empty': {
    display: 'none',
  },
  [mediaQuery(640)]: {
    marginBottom: 34,
  },
});

export default StyledFieldWrapper;
